import { Component, type ErrorInfo, type ReactNode } from "react";
import { ErrorFallback } from "./ErrorFallback.tsx";

interface Props {
  children?: ReactNode;
  helpCenter: string;
  onError?: (eror: Error, errorInfo: ErrorInfo) => void;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (import.meta.env.DEV && errorInfo?.componentStack) {
      console.log(errorInfo.componentStack);
    }
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorFallback helpCenter={this.props.helpCenter} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
